import { createFileRoute } from "@tanstack/react-router";
import ZonasExclusivas from "@/pages/ZonasExclusivas";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Zonas exclusivas", path: "/zonas-exclusivas" }]);

export const Route = createFileRoute("/zonas-exclusivas")({
  head: () => ({
    meta: [
      { title: "Zonas Exclusivas | SEOEVOLUTION - SEO con Exclusividad por Zona" },
      {
        name: "description",
        content:
          "Operamos en toda España con exclusividad por sector y zona. Selecciona tu provincia para ver la disponibilidad en tu zona.",
      },
      { name: "robots", content: "index, follow" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/zonas-exclusivas" },
      { property: "og:title", content: "Zonas Exclusivas | SEOEVOLUTION - SEO con Exclusividad por Zona" },
      {
        property: "og:description",
        content:
          "Operamos en toda España con exclusividad por sector y zona. Selecciona tu provincia para ver la disponibilidad en tu zona.",
      },
      { name: "twitter:title", content: "Zonas Exclusivas | SEOEVOLUTION - SEO con Exclusividad por Zona" },
      {
        name: "twitter:description",
        content:
          "Operamos en toda España con exclusividad por sector y zona. Selecciona tu provincia para ver la disponibilidad en tu zona.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/zonas-exclusivas" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: ZonasExclusivas,
});
